// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1x13l","icon":"styles_icon__1wRdb"};